export default __webpack_public_path__ + "static/media/arrow-left-right.9411fe49.svg";